import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { requestCompletenessStatusForFinSobSidePanelItem } from './api/requestCompletenessStatusForFinSobSidePanelItem'
import { requestFinSobSidePanelSettings } from './api/requestFinSobSidePanelSettings'
import { PARTNER360_FIN_SOB_SIDE_PANEL_NAMESPACE } from './constants'
import { IActionSelectFinSobItem } from './models/actionSelectFinSobItem'
import { initialState } from './сonfigs'

const finSobSidePanelSlice = createSlice({
  name: PARTNER360_FIN_SOB_SIDE_PANEL_NAMESPACE,
  initialState,
  reducers: {
    changeFinSobItem: (
      state,
      { payload: { item, programType } }: PayloadAction<IActionSelectFinSobItem>
    ) => {
      const data = state.data[programType]
      const selectedItem = state.selectedItem[programType]
      if (data) {
        const foundIndex = data.findIndex((el) => el.EntryId === item.EntryId)
        if (foundIndex > -1) {
          data[foundIndex] = item
          state.data[programType] = data

          if (selectedItem && item.EntryId === selectedItem.EntryId) {
            state.selectedItem[programType] = item
          }
        }
      }
    },
    selectFinSobItem: (
      state,
      { payload: { item, programType } }: PayloadAction<IActionSelectFinSobItem>
    ) => {
      state.selectedItem[programType] = item
    },
  },
  extraReducers(builder) {
    builder
      .addCase(requestFinSobSidePanelSettings.pending, (state) => {
        state.fetchStatus = RequestStatus.PENDING
      })
      .addCase(requestFinSobSidePanelSettings.rejected, (state) => {
        state.fetchStatus = RequestStatus.REJECTED
      })
      .addCase(requestFinSobSidePanelSettings.fulfilled, (state, action) => {
        if (action.payload) {
          const { programType, data } = action.payload
          state.data[programType] = data
          state.selectedItem[programType] = data[0]
          state.fetchStatus = RequestStatus.FULFILLED
        }
      })

      .addCase(requestCompletenessStatusForFinSobSidePanelItem.pending, (state, action) => {
        const { category } = action.meta.arg
        state.categoryWithLoadingCompletenessStatus = category
      })
      .addCase(requestCompletenessStatusForFinSobSidePanelItem.fulfilled, (state, action) => {
        if (action.payload) {
          const { programType, data } = action.payload
          state.data[programType] = data
          state.categoryWithLoadingCompletenessStatus = null
        }
      })
  },
})

export const { selectFinSobItem, changeFinSobItem } = finSobSidePanelSlice.actions

export default finSobSidePanelSlice.reducer
